import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  Fragment,
} from "react";
import { Link } from "react-router-dom";
import {
  getAppointments,
  updateAppointmentStatus,
} from "../API/AppointmentsApi";
import { getFacilityDetails } from "../API/FacilitySettingsApi";
import AuthContext from "../Context/AuthProvider";
import {
  compareDates,
  convertToUTC,
  convertUTCToTimeZone,
  convertUTCToTimeZoneDateTimeString,
} from "../Utility/DateTimeUtility";
import {
  AppointmentStatus,
  DateRangeOptions,
  MedicalRecordTypes,
  NoteTypes,
  PrescriptionTypes,
  ServiceStatus,
} from "../Utility/Constants";
import {
  getDisplayValue,
  getLabelOfPrescriptionTypes,
  showLoadingImage,
} from "../Utility/Utility";
import ConfirmationDialog from "../common/ConfirmationDialog";
import MoreVert from "@mui/icons-material/MoreVert";
import ListItemIcon from "@mui/material/ListItemIcon";
import { DataGrid, GridPinnedColumnPosition } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Fab,
  Grid2,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  Card,
  CardContent,
  CardActions,
  Divider,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import dayjs from "dayjs";
import {
  Done,
  LocalParkingRounded,
  PlayCircleOutline,
  Undo,
} from "@mui/icons-material";
// import { getVisits } from "../API/VisitsApi";
import {
  getMyAssignedServices,
  updateServiceStatus,
} from "../API/LinkedServicesApi";
import { useSnackbar } from "../Utility/UserMessageContext";
import DateRangeDialog from "../Appointments/ChangeDates";
// import { PinnedColumnPosition } from "@mui/x-data-grid/internals";
import { formatAge } from "../Utility/Utility";
import MenuBar from "../common/MenuBar";
// import { getVisitByFacility } from "../API/VisitsApi";
import { AvailablePrescriptionTypes } from "../Utility/Constants";
function MyWorlist({
  onViewDetails,
  onAddNewPrescription,
  onAddNote,
  onAddMedicalRecord,
  onAddLaboratoryTest,
  onViewVisitDetails,
  onViewPatientDetails,
  onAddServices,
  onAddWhiteboard,
  onAddTLDraw,
}) {
  const { auth } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // const [searchedResultAppointments, setSearchedResultAppointments] =
  //   useState();
  // const [prescriptions, setPrescriptions] = useState();
  // const [searchableAppointments, setSearchableAppointments] = useState();
  // const [searchText, setSearchText] = useState();
  const [allAppointments, setAllAppointments] = useState([]); // Initialize as empty array
  const [dataLoaded, setDataLoaded] = useState(false); // Add a state to track if data has been loaded
  // const [flattendAppointments, setFlattendAppointments] = useState();
  const [openUndoDialog, setOpenUndoDialog] = useState(false);
  const [undoServiceData, setUndoServiceData] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState();
  const [openStatusConfirmDialog, setOpenStatusConfirmDialog] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const checkInPatientModalId = "checkIn" + selectedAppointment?.id;
  const [showQueue, setShowQueue] = useState();
  const [actionsMenuAnchor, setActionsMenuAnchor] = useState(null);
  const [outcomeMenuAnchor, setOutcomeMenuAnchor] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);
  const handleMenuOpen = (event, row) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRow(row); // Keep track of the selected row
  };
  const [filters, setFilters] = useState({
    from: dayjs(new Date()),
    to: dayjs(new Date()),
    selectedDateRangeOption: DateRangeOptions.Today,
  });
  const handleActionsMenuOpen = (event, row) => {
    setActionsMenuAnchor(event.currentTarget);
    setCurrentRow(row);
  };

  const handleOutcomeMenuOpen = (event, row) => {
    setOutcomeMenuAnchor(event.currentTarget);
    setCurrentRow(row);
  };

  const handleMenuClose = () => {
    setActionsMenuAnchor(null);
    setOutcomeMenuAnchor(null);
    setCurrentRow(null);
  };

  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchData = async () => {
      setShowSpinner(true);
      setDataLoaded(false); // Reset data loaded state when fetching

      var result = await getMyAssignedServices(
        auth,
        convertToUTC(
          dayjs(filters.from)
            .set("hour", 0)
            .set("minute", 0)
            .set("second", 0)
            .set("millisecond", 0),
        ),
        convertToUTC(
          dayjs(filters.to)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .set("millisecond", 999),
        ),
      );
      if (result.isSuccess) {
        setAllAppointments(result?.data || []); // Set empty array if data is null/undefined
      } else {
        setAllAppointments([]); // Set empty array in case of error
      }

      setDataLoaded(true); // Mark data as loaded regardless of success/failure
      setShowSpinner(false);
    };

    fetchData();
  }, [auth, filters]);

  const [pageSize, setPageSize] = useState(20);

  const onStatusChanged = async (serviceId, newStatus) => {
    var result = await updateServiceStatus(auth, serviceId, newStatus);
    if (result.isSuccess) {
      refreshList();
    } else {
      showSnackbar(result?.data, "error");
    }
  };

  // Add this function after the onStatusChanged function (around line 180)
  const handleUndoStatus = (service) => {
    setSelectedService(service);
    setPendingStatusChange("undo");
    setOpenStatusConfirmDialog(true);
  };

  const handleCompleteService = (service) => {
    setSelectedService(service);
    setPendingStatusChange("complete");
    setOpenStatusConfirmDialog(true);
  };

  const confirmUndoStatus = async () => {
    if (!undoServiceData) return;

    let newStatus;
    if (undoServiceData.status === ServiceStatus.Completed) {
      newStatus = ServiceStatus.InProgress;
    } else if (undoServiceData.status === ServiceStatus.InProgress) {
      newStatus = ServiceStatus.NotStarted;
    }

    await onStatusChanged(undoServiceData.id, newStatus);

    setOpenUndoDialog(false);
    setUndoServiceData(null);
  };

  const refreshList = async () => {
    setShowSpinner(true);
    setDataLoaded(false); // Reset data loaded state when refreshing

    var result = await getMyAssignedServices(
      auth,
      convertToUTC(
        dayjs(filters.from)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0),
      ),
      convertToUTC(
        dayjs(filters.to)
          .set("hour", 23)
          .set("minute", 59)
          .set("second", 59)
          .set("millisecond", 999),
      ),
    );

    if (result.isSuccess) {
      setAllAppointments(result?.data || []); // Set empty array if data is null/undefined
    } else {
      setAllAppointments([]); // Set empty array in case of error
    }

    setDataLoaded(true); // Mark data as loaded regardless of success/failure
    setShowSpinner(false);
  };

  // Custom function to control when to show the "no rows" message
  const getNoRowsOverlay = () => {
    if (showSpinner || !dataLoaded) {
      // If still loading or data hasn't been loaded yet, don't show any message
      return "";
    }
    // Only show the message when data is loaded and there are no rows
    return "There are no services to display. Change the dates to view your worklist.";
  };
  const confirmStatusChange = async () => {
    if (!selectedService) return;

    let newStatus;

    if (pendingStatusChange === "complete") {
      newStatus = ServiceStatus.Completed;
    } else if (pendingStatusChange === "undo") {
      if (selectedService.status === ServiceStatus.Completed) {
        newStatus = ServiceStatus.InProgress;
      } else if (selectedService.status === ServiceStatus.InProgress) {
        newStatus = ServiceStatus.NotStarted;
      }
    }

    if (newStatus) {
      await onStatusChanged(selectedService.id, newStatus);
    }

    setOpenStatusConfirmDialog(false);
    setPendingStatusChange(null);
    setSelectedService(null);
  };

  const renderServiceCards = () => (
    <Grid2
      container
      spacing={2}
      sx={{
        width: "100%",
        maxHeight: "calc(100vh - 170px)",
        overflowY: "auto",
      }}
    >
      <Box sx={{ px: 1 }}>
        {allAppointments.map((service) => (
          <Card
            key={service.id}
            variant="outlined"
            sx={{ mb: 2, borderRadius: 2 }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mb: 1,
                }}
              >
                <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                  {`${service.patientPrefix || ""} ${
                    service.patientFirstName || ""
                  } ${service.patientLastName || ""}`.trim()}
                </Typography>
                <Chip
                  label={getDisplayValue(service.status)}
                  color={
                    service.status === ServiceStatus.Completed
                      ? "success"
                      : service.status === ServiceStatus.InProgress
                        ? "primary"
                        : "default"
                  }
                  size="small"
                />
              </Box>

              <Divider sx={{ my: 1 }} />

              {/* Display everything one below another */}
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>ID:</strong> {service.displayId}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Gender:</strong> {service.patientGender}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Age:</strong> {formatAge(service.patientAgeInYears)}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Contact:</strong> {service.patientMobileNo}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Email:</strong> {service.patientEmailId}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Service:</strong> {service.serviceName}
              </Typography>

              <Typography variant="body2" sx={{ mb: 2 }}>
                <strong>Scheduled:</strong>{" "}
                {convertUTCToTimeZoneDateTimeString(
                  service.scheduledStartDateTime,
                  auth?.selectedFacility?.timeZone,
                )}
              </Typography>
            </CardContent>

            <CardActions
              sx={{
                justifyContent: "flex-end",
                px: 2,
                pb: 2,
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Tooltip title="View Details" arrow placement="top">
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => onViewDetails(service)}
                >
                  <EventNoteOutlinedIcon />
                </IconButton>
              </Tooltip>

              {service.status !== ServiceStatus.InProgress &&
                service.status !== ServiceStatus.Completed && (
                  <Tooltip title="Start Service" arrow placement="top">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() =>
                        onStatusChanged(service.id, ServiceStatus.InProgress)
                      }
                    >
                      <PlayCircleOutline />
                    </IconButton>
                  </Tooltip>
                )}

              {(service.status === ServiceStatus.InProgress ||
                service.status === ServiceStatus.Completed) && (
                <Tooltip title="Undo Status" arrow placement="top">
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={() => handleUndoStatus(service)} // Changed this line
                  >
                    <Undo />
                  </IconButton>
                </Tooltip>
              )}

              {service.status === ServiceStatus.InProgress && (
                <>
                  <Tooltip title="Complete Service" arrow placement="top">
                    <IconButton
                      size="small"
                      color="success"
                      onClick={() =>
                        onStatusChanged(service.id, ServiceStatus.Completed)
                      }
                    >
                      <Done />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Add Record" arrow placement="top">
                    <IconButton
                      size="small"
                      color="default"
                      onClick={(event) => handleOutcomeMenuOpen(event, service)}
                    >
                      <AddRoundedIcon />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </CardActions>
          </Card>
        ))}

        {dataLoaded && allAppointments.length === 0 && !showSpinner && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              There are no services to display. Change the dates to view your
              worklist.
            </Typography>
          </Box>
        )}

        {showSpinner && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Loading...
            </Typography>
          </Box>
        )}
      </Box>
    </Grid2>
  );

  // const columns = [
  // { field: "displayId", headerName: "ID", width: 180 },
  // { field: "visitDisplayId", headerName: "Visit #", width: 180 },
  const columns = [
    {
      field: "displayId",
      headerName: "ID",
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <span
            style={{
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => onViewDetails(params.row)}
          >
            {params.row.displayId}
          </span>

          {/* Three dots menu for all actions */}
          <Tooltip title="Actions" arrow>
            <IconButton
              size="small"
              onClick={(event) => handleActionsMenuOpen(event, params.row)}
            >
              <MoreVert fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: "visitDisplayId",
      headerName: "Visit #",
      width: 180,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <span
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={async () => {
              onViewVisitDetails &&
                onViewVisitDetails(
                  params.row.visitId,
                  params.row.visitDisplayId,
                );
            }}
          >
            {params.row.visitDisplayId}
          </span>
          {params?.row?.isLinkedWithPlan && (
            <Tooltip title="Linked to Plan" arrow>
              <LocalParkingRounded fontSize="4" />
            </Tooltip>
          )}
        </Box>
      ),
    },
    {
      field: "patient",
      type: "text",
      headerName: " Name",
      width: 180,
      renderCell: (params) => {
        const visit = params?.row?.visits?.[0];
        const patientPrefix = params.row.patientPrefix || "";
        const firstName = params.row.patientFirstName || "";
        const lastName = params.row.patientLastName || "";
        const gender = params.row.patientGender || "";
        const age = params.row.patientAgeInYears || "";
        const phone = params.row.patientMobileNo || "";
        const countryCode = params?.row?.countryCodeForPhone || "";
        const email = params?.row?.patientEmailId || "";

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
              lineHeight: 1.3,
            }}
          >
            <div>
              <span
                style={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const patientData = {
                    id: params.row.patientId,
                    firstName: params.row.patientFirstName,
                    lastName: params.row.patientLastName,
                    prefix: params.row.patientPrefix,
                    gender: params.row.patientGender,
                    ageInYears: params.row.patientAgeInYears,
                    mobileNo: params.row.patientMobileNo,
                    emailId: params.row.patientEmailId,
                  };
                  onViewPatientDetails(patientData);
                }}
              >
                {patientPrefix} {firstName} {lastName}
              </span>
              <span style={{ fontWeight: "normal" }}> ({gender})</span>
            </div>

            <span style={{ color: "#555", fontSize: "0.85em" }}>
              {`${countryCode} ${phone} (${formatAge(age)})`}
              <br />
            </span>
          </div>
        );
      },
    },
    {
      field: "serviceName",
      headerName: "Service",
      width: 180,
      renderCell: (params) => params?.row?.primaryServiceName,
    },
    {
      field: "scheduledStartDateTime",
      headerName: "Scheduled Time",
      width: 220,
      valueGetter: (params) =>
        convertUTCToTimeZoneDateTimeString(
          params,
          auth?.selectedFacility?.timeZone,
        ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      renderCell: (params) => getDisplayValue(params?.row?.status),
    },
  ];

  return (
    <>
      <Grid2 containe size={12}>
        <Grid2 container size={12}>
          <Grid2 size={12}>
            <MenuBar
              showChangeDate={true}
              onChangeDate={() => setOpenDateRangeDialog(true)}
              disabled={false}
            />
          </Grid2>
          {/* Date Range Display */}
          <Grid2 size={12} sx={{ px: 1, py: 1 }}>
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: "0.75rem",
                  sm: "0.875rem",
                  md: "1rem",
                  lg: "1.125rem",
                  xl: "1.25rem",
                },
              }}
            >
              Showing worklist from {filters?.from?.format("DD/MM/YYYY")} to{" "}
              {filters?.to?.format("DD/MM/YYYY")}
            </Typography>
          </Grid2>
        </Grid2>

        {/* Conditional rendering based on screen size */}
        {isMobile ? (
          // Mobile Card View
          <Box sx={{ width: "100%", paddingX: "5px" }}>
            {renderServiceCards()}
          </Box>
        ) : (
          // Desktop DataGrid View

          <Grid2
            container
            size={12}
            sx={{
              maxHeight: "calc(100vh - 170px)",
              overflowY: "auto",
              display: "flex",
              width: showQueue ? "80%" : "100%",
              transition: "width 1s ease",
              paddingX: "5px",
              height: 600,
              //overflow: "auto", // Enable scrolling when content overflows
              // Adjust as needed for your layout
            }}
          >
            <DataGrid
              localeText={{
                noRowsLabel: getNoRowsOverlay(),
              }}
              loading={showSpinner || !dataLoaded}
              slotProps={{
                loadingOverlay: {
                  variant: "skeleton",
                  noRowsVariant: "skeleton",
                },
              }}
              initialState={{
                density: "compact",
                pagination: {
                  paginationModel: { pageSize: 20 },
                },
              }}
              sx={{
                width: "200px",
                overflow: "hidden",
                "& .sticky-column": {
                  position: "sticky",
                  right: 0,
                  backgroundColor: "white",
                  zIndex: 100,
                },
                "& .MuiTablePagination-toolbar": {
                  minHeight: "unset",
                  alignItems: "center",
                  paddingTop: "0 !important",
                  paddingBottom: "0 !important",
                },
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                  {
                    margin: 0,
                  },
              }}
              rowHeight={65}
              rows={allAppointments}
              columns={columns}
              pageSizeOptions={[5, 10, 15, 20]}
              rowsPerPageOptions={[5, 10, 15, 20]}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          </Grid2>
        )}
        {/* Main Actions Menu */}
        <Menu
          anchorEl={actionsMenuAnchor}
          open={Boolean(actionsMenuAnchor)}
          onClose={handleMenuClose}
        >
          {currentRow && (
            <>
              {/* View Details */}
              <MenuItem
                onClick={() => {
                  onViewDetails(currentRow);
                  handleMenuClose();
                }}
              >
                <ListItemIcon>
                  <EventNoteOutlinedIcon fontSize="small" />
                </ListItemIcon>
                View Details
              </MenuItem>

              {/* Status Management Actions */}
              {currentRow.status !== ServiceStatus.InProgress &&
                currentRow.status !== ServiceStatus.Completed && (
                  <MenuItem
                    onClick={() => {
                      onStatusChanged(currentRow.id, ServiceStatus.InProgress);
                      handleMenuClose();
                    }}
                  >
                    <ListItemIcon>
                      <PlayCircleOutline fontSize="small" />
                    </ListItemIcon>
                    Start Service
                  </MenuItem>
                )}
              {(currentRow.status === ServiceStatus.InProgress ||
                currentRow.status === ServiceStatus.Completed) && (
                <MenuItem
                  onClick={() => {
                    handleUndoStatus(currentRow); // Changed this line
                    handleMenuClose();
                  }}
                >
                  <ListItemIcon>
                    <Undo fontSize="small" />
                  </ListItemIcon>
                  Undo Status
                </MenuItem>
              )}
              {currentRow.status === ServiceStatus.InProgress && (
                <MenuItem
                  onClick={() => {
                    handleCompleteService(currentRow);
                    handleMenuClose();
                  }}
                >
                  <ListItemIcon>
                    <Done fontSize="small" />
                  </ListItemIcon>
                  Complete Service
                </MenuItem>
              )}

              {currentRow.status === ServiceStatus.InProgress && (
                <>
                  {/* Add Outcome Menu Item - Opens nested menu without closing this one */}
                  <MenuItem
                    onClick={(event) => {
                      // Only open outcome menu, don't close the current menu
                      handleOutcomeMenuOpen(event, currentRow);
                    }}
                  >
                    <ListItemIcon>
                      <AddRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Add Record
                  </MenuItem>
                </>
              )}
            </>
          )}
        </Menu>

        {/* Outcome Options Menu */}
        <Menu
          anchorEl={outcomeMenuAnchor}
          open={Boolean(outcomeMenuAnchor)}
          onClose={() => {
            setOutcomeMenuAnchor(null);
            // Don't close the main menu when outcome menu closes
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {currentRow && currentRow.status === ServiceStatus.InProgress && (
            <>
              {(() => {
                const allowedTypes =
                  auth?.selectedFacility?.licenseDetails
                    ?.allowedPrescriptions ||
                  AvailablePrescriptionTypes.map((type) => type.value);

                return (
                  <>
                    {/* General Prescription */}
                    {allowedTypes.includes(
                      PrescriptionTypes.GeneralPrescription,
                    ) && (
                      <MenuItem
                        onClick={() => {
                          onAddNewPrescription(
                            currentRow?.id,
                            PrescriptionTypes.GeneralPrescription,
                            currentRow?.patientFirstName +
                              " " +
                              currentRow?.patientLastName,
                          );
                          // Close both menus when an option is selected
                          handleMenuClose();
                        }}
                      >
                        {getLabelOfPrescriptionTypes(
                          PrescriptionTypes.GeneralPrescription,
                        )}
                      </MenuItem>
                    )}

                    {/* Physiotherapy Prescription */}
                    {allowedTypes.includes(
                      PrescriptionTypes.PhysiotherapyPrescription,
                    ) && (
                      <MenuItem
                        onClick={() => {
                          onAddNewPrescription(
                            currentRow?.id,
                            PrescriptionTypes.PhysiotherapyPrescription,
                            currentRow?.patientFirstName +
                              " " +
                              currentRow?.patientLastName,
                          );
                          handleMenuClose();
                        }}
                      >
                        {getLabelOfPrescriptionTypes(
                          PrescriptionTypes.PhysiotherapyPrescription,
                        )}
                      </MenuItem>
                    )}

                    {/* Pathology Lab Report */}
                    {allowedTypes.includes(
                      PrescriptionTypes.PathologyLabReport,
                    ) && (
                      <MenuItem
                        onClick={() => {
                          onAddNewPrescription(
                            currentRow?.id,
                            PrescriptionTypes.PathologyLabReport,
                            currentRow?.patientFirstName +
                              " " +
                              currentRow?.patientLastName,
                          );
                          handleMenuClose();
                        }}
                      >
                        {getLabelOfPrescriptionTypes(
                          PrescriptionTypes.PathologyLabReport,
                        )}
                      </MenuItem>
                    )}
                    {allowedTypes.includes(
                      PrescriptionTypes.FrozenShoulder,
                    ) && (
                      <MenuItem
                        onClick={() => {
                          onAddNewPrescription(
                            currentRow?.id,
                            PrescriptionTypes.FrozenShoulder,
                            currentRow?.patientFirstName +
                              " " +
                              currentRow?.patientLastName,
                          );
                          handleMenuClose();
                        }}
                      >
                        {getLabelOfPrescriptionTypes(
                          PrescriptionTypes.FrozenShoulder,
                        )}
                      </MenuItem>
                    )}
                    {/* Dental Prescription  */}
                    {allowedTypes.includes(
                      PrescriptionTypes.DentalPrescription,
                    ) && (
                      <MenuItem
                        onClick={() => {
                          onAddNewPrescription(
                            currentRow?.id,
                            PrescriptionTypes.DentalPrescription,
                            currentRow?.patientFirstName +
                              " " +
                              currentRow?.patientLastName,
                          );
                          handleMenuClose();
                        }}
                      >
                        {getLabelOfPrescriptionTypes(
                          PrescriptionTypes.DentalPrescription,
                        )}
                      </MenuItem>
                    )}

                    {/* Notes - Show if any note type is available */}
                    {(allowedTypes.includes("General") ||
                      allowedTypes.includes("PhysiotherapyTreatment")) && (
                      <MenuItem
                        onClick={() => {
                          onAddNote(currentRow?.id);
                          handleMenuClose();
                        }}
                      >
                        {getLabelOfPrescriptionTypes(NoteTypes[2].value)}
                      </MenuItem>
                    )}

                    {/* Medical Records */}
                    {allowedTypes.includes("MedicalRecord") && (
                      <MenuItem
                        onClick={() => {
                          onAddMedicalRecord(currentRow?.id);
                          handleMenuClose();
                        }}
                      >
                        {getLabelOfPrescriptionTypes(
                          MedicalRecordTypes[0].value,
                        )}
                      </MenuItem>
                    )}
                    {/* Medical Records */}
                    {/* {allowedTypes.includes("MedicalRecord") && (
  <MenuItem
    onClick={() => {
      onAddMedicalRecord(currentRow?.id);
      handleMenuClose();
    }}
  >
    {getLabelOfPrescriptionTypes(MedicalRecordTypes[0].value)}
  </MenuItem>
)} */}

                    {/* Whiteboard — ADD THIS */}
                    {/* {allowedTypes.includes("Whiteboard") && (
  <MenuItem
    onClick={() => {
      onAddWhiteboard(currentRow?.id);   // ✅ yeh call hoga
      handleMenuClose();
    }}
  >
     Whiteboard
  </MenuItem>
)} */}

                    {/* tldraw whiteboard — ADD THIS */}
                    {allowedTypes.includes("Whiteboard") && (
                      <MenuItem
                        onClick={() => {
                          onAddTLDraw(currentRow?.id); // ✅ yeh call hoga
                          handleMenuClose();
                        }}
                      >
                        Drawing
                      </MenuItem>
                    )}
                  </>
                );
              })()}
            </>
          )}
        </Menu>
      </Grid2>

      <DateRangeDialog
        key="worklist"
        title="Show Worklist For"
        filters={filters}
        setFilters={setFilters}
        openState={openDateRangeDialog}
        setOpenState={setOpenDateRangeDialog}
        // onApply={handleApplyDateRange}
      ></DateRangeDialog>
      <ConfirmationDialog
        open={openStatusConfirmDialog}
        onClose={() => {
          setOpenStatusConfirmDialog(false);
          setPendingStatusChange(null);
          setSelectedService(null);
        }}
        onConfirm={confirmStatusChange}
        title={
          pendingStatusChange === "complete"
            ? "Confirm Complete Service"
            : "Confirm Undo Status"
        }
        okButtonColor="secondary" // Changed from success to secondary
        statement={
          pendingStatusChange === "complete"
            ? "Are you sure you want to mark this service as completed?"
            : selectedService?.status === ServiceStatus.Completed
              ? "Are you sure you want to change status from Completed to In Progress?"
              : selectedService?.status === ServiceStatus.InProgress
                ? "Are you sure you want to change status from In Progress to Not Started?"
                : "Are you sure you want to undo this status?"
        }
      />
    </>
  );
}

export default MyWorlist;
